module.exports = __webpack_public_path__ + "media/images/flags/4x3/svn-bc8b5ad628c497268ef18d1dd17b543b.svg";